import {Injector} from '@angular/core';

/**
 * @see https://stackoverflow.com/a/42462579
 */
export class ServiceLocator {
    static injector: Injector;
}


// WEBPACK FOOTER //
// /app/src/services/locator.service.ts